import { render, staticRenderFns } from "./a-v-datatable.vue?vue&type=template&id=06c817e8"
import script from "./a-v-datatable.vue?vue&type=script&lang=js"
export * from "./a-v-datatable.vue?vue&type=script&lang=js"
import style0 from "./a-v-datatable.vue?vue&type=style&index=0&id=06c817e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports